module.exports = __webpack_public_path__ + "order/img/VI.fc63e961.svg";